export default __webpack_public_path__ + "static/media/contact-2.12ff67a2.png";